import createHistory from 'history/createBrowserHistory';

const history = createHistory({ basename: '/appraiser-registration' });

export default history;
